module.exports = __webpack_public_path__ + "img/logo-edeka-full.16bcdca6.png";